/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Driver_CashInputs */

const vi_nav_driver_cash = /** @type {(inputs: Nav_Driver_CashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quỹ của tôi`)
};

/**

* @param {Nav_Driver_CashInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_driver_cash = /** @type {((inputs?: Nav_Driver_CashInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Driver_CashInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_driver_cash(inputs)
});